import axios from 'axios'
import { i18n } from '../../plugins/i18n'

export const companiesStores = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    errors: null,
  },
  mutations: {
    readStores(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readStoresSuccess(state, payload) {
      state.data = payload
      state.loading = false
      state.loadError = false
    },
    readStoresFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    },
    deleteStore(state) {
      state.data = null
      state.loading = false
      state.loadError = false
    }
  },
  getters: {
    stores(state) {
      if (!state.data) return []
      return state.data.data
    },
    isEmpty(state) {
      if (!state.data) return true
      return state.data.data.length === 0
    },
    hasVisibleStores(state) {
      if (!state.data) return false
      return state.data.data.some(field => field.attributes.visible)
    },
  },
  actions: {
    readStores({ commit }, company_uuid) {
      commit('readStores')
      return axios
        .get('/api/companies/' + company_uuid + '/stores.json')
        .then(res => {
          commit('readStoresSuccess', res.data)
        })
        .catch(err => {
          commit('readStoresFailure', err)
          console.error(err)
        })
    },
    deleteStore({ commit }, { companyUuid, uuid }) {
      return axios
        .delete('/api/companies/' + companyUuid + '/stores/' + uuid)
        .then(() => {
          commit('deleteStore')
          alert(i18n.t('messages.deletedDelay', { value: i18n.t('models.store.modelName') }))
        })
        .catch(err => {
          console.error(err)
          alert(i18n.t('messages.deletedError'))
        })
    }
  }
}
